import { createApiCall } from 'lib/base';

const EDIT_SUBSCRIPTION_OPTION = 'EDIT_SUBSCRIPTION_OPTION';

const editSubscriptionOptionApi = createApiCall<{
  id: string;
  optionId: string;
  payload: any;
}>(EDIT_SUBSCRIPTION_OPTION, ({ id, optionId, payload }) => ({
  endpoint: `api/admin/subscriptions/${id}/options/${optionId}`,
  method: 'PATCH',
  body: payload,
}));

export default editSubscriptionOptionApi;
